import React from "react";

import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";
import SelectorHora from "../../general/SelectorHora";
import { getElementosHora } from "../../../../resources/Helper";

function EditarBloqueo() {

    const queryParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');
    
    const [agendas, setAgendas] = useState([]);
    const [descripcion, setDescripcion] = useState();
    const [agenda, setAgenda] = useState();
    const [nombreAgenda, setNombreAgenda] = useState();
    const [horaInicio, setHoraInicio] = useState();
    const [horaFin, setHoraFin] = useState();
    const [fechaInicio, setFechaInicio] = useState();
    const [fechaFin, setFechaFin] = useState();
    const [fechaFinRepeticion, setFechaFinRepeticion] = useState();
    const [frecuencia, setFrecuencia] = useState(0);

    const [showFechas, setShowFechas] = useState('hide');

    const [horaInicioBloqueo, setHoraInicioBloqueo] = useState();
    const [minutoInicioBloqueo, setMinutoInicioBloqueo] = useState();
    const [ampmInicioBloqueo, setAmpmInicioBloqueo] = useState();

    const [horaFinBloqueo, setHoraFinBloqueo] = useState();
    const [minutoFinBloqueo, setMinutoFinBloqueo] = useState();
    const [ampmFinBloqueo, setAmpmFinBloqueo] = useState();

    const [opcionesRepeticion, setOpcionesRepeticion] = useState([]);

    let history = useHistory();

    let userdata = [];

    const [errorlist, setErrorlist] = useState({});

    useEffect(()=>{ 

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        
        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        // ✅ Cargar agendas usando axios - el backend obtiene client_id del token
        axios.get('/listado-agendas')
            .then(response => {
                setAgendas(response.data);
            })
            .catch(error => {
                console.error('Error cargando agendas:', error);
            });

        // ✅ Cargar bloqueo usando params en config
        axios.get('/bloqueo', {
            params: {
                uid: userdata.user_id,
                id: id
            }
        })
            .then(response => {
                console.log(response.data[0]);
                setDescripcion(response.data[0].descripcion);
                setAgenda(response.data[0].id_users); // id_users contiene el id de la agenda
                setHoraInicio(response.data[0].hora_inicio);
                setHoraFin(response.data[0].hora_fin);
                setFechaInicio(response.data[0].fecha_inicio);
                setFechaFin(response.data[0].fecha_fin);
                setFrecuencia(response.data[0].frecuencia);
                setFechaFinRepeticion(response.data[0].fecha_fin_repeticion);

                let elementosHoraInicio = getElementosHora(response.data[0].hora_inicio);
                let elementosHoraFin = getElementosHora(response.data[0].hora_fin);

                setHoraInicioBloqueo(elementosHoraInicio[0]);
                setMinutoInicioBloqueo(elementosHoraInicio[1]);
                setAmpmInicioBloqueo(elementosHoraInicio[2]);

                setHoraFinBloqueo(elementosHoraFin[0]);
                setMinutoFinBloqueo(elementosHoraFin[1]);
                setAmpmFinBloqueo(elementosHoraFin[2]);
            })
            .catch(error => {
                console.log(error);
            });
    },[]);



    useEffect(() => {
        if (frecuencia!=0) {
            setShowFechas('');
        }
        else {
            setShowFechas('hide');
        }
    },[frecuencia]);



    useEffect(() => {
        if (fechaInicio==fechaFin) {
            setOpcionesRepeticion([ 
                { value: '', text: 'Nunca', visible: true },  
                { value: 'dias', text: 'Todos los días', visible: true },
                { value: 'semana', text: 'Cada semana', visible: true },
                { value: 'mes', text: 'Cada mes', visible: true }
            ]);
        }
        else {
            setOpcionesRepeticion([ 
                { value: '', text: 'Nunca', visible: true },  
                { value: 'dias', text: 'Todos los días', visible: false },
                { value: 'semana', text: 'Cada semana', visible: true },
                { value: 'mes', text: 'Cada mes', visible: true }
            ]);
        }
    },[fechaFin]);


    useEffect(() => {
        for (let k=0;k<agendas.length;k++) {
            if (agendas[k].id==agenda) {
                setNombreAgenda(agendas[k].nombre);
                break;
            }
        }
    },[agenda]);


    const handleSubmit = (e) => {
        e.preventDefault();
        
        // ✅ Validar campos requeridos
        if (!descripcion || !agenda || !horaInicio || !horaFin || !fechaInicio || !fechaFin) {
            alert('Por favor complete todos los campos requeridos');
            return;
        }
        
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // ✅ Ya NO necesitas headers - el interceptor agrega el token automáticamente
        const conf = {
            id: id,
            id_client: client.client_id,
            descripcion: descripcion,
            id_users: agenda, // id_users contiene el id de la agenda
            hora_inicio: horaInicio,
            hora_fin: horaFin,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin,
            frecuencia: frecuencia || '',
            fecha_fin_repeticion: fechaFinRepeticion || null,
            fecha_hora_inicio: fechaInicio+" "+horaInicio, // SelectorHora ya incluye :00
            fecha_hora_fin: fechaFin+" "+horaFin // SelectorHora ya incluye :00
        };
        
        axios.put('/bloqueo', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg','El bloqueo ha sido modificado');
                    history.push('/bloqueos-agenda');
                }
            )
            .catch(
                err => {
                    console.error('Error guardando bloqueo:', err);
                    // ✅ Manejar errores de validación del backend
                    if (err.response && err.response.data && err.response.data.errors) {
                        setErrorlist(err.response.data.errors);
                    } else {
                        alert('Error al guardar el bloqueo. Por favor, intente nuevamente.');
                    }
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/bloqueos-agenda">Bloqueos de Agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Editar Bloqueo</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar Bloqueo</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">
                                    
                                    <form id="role-form" onSubmit={handleSubmit} autoComplete={'off'}>
                                        <div className="card">
                                            <div id="infobasica">
                                                <div className="card-body">

                                                    
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="descripcion">Descripción del bloqueo</label>
                                                                <input 
                                                                    type="text" 
                                                                    name="descripcion" 
                                                                    className="form-control" 
                                                                    id="descripcion" 
                                                                    defaultValue={descripcion} 
                                                                    onChange={(e) => setDescripcion(e.target.value)}
                                                                    required
                                                                    disabled={loading}
                                                                />
                                                                {errorlist && errorlist.descripcion && (
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.descripcion}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="agenda">Agenda a bloquear</label>
                                                                <select name="agenda" className="form-control" id="agenda" value={agenda} onChange={(e) => setAgenda(e.target.value)}>
                                                                    <option key={'ag0'}></option>
                                                                    {
                                                                        agendas.map((ag) => 
                                                                            <option key={'ag'+ag.id} value={ag.id}>{ag.nombre}</option>
                                                                        )
                                                                    }
                                                                </select>
                                                                {errorlist && errorlist.id_agenda && (
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.id_agenda}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaInicio">Fecha inicio</label>
                                                                <input type="date" name="fechaInicio" className="form-control" id="fechaInicio" defaultValue={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
                                                                {errorlist && errorlist.fecha_inicio && (
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.fecha_inicio}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="horaInicio">Hora de inicio</label>
                                                                <SelectorHora onChange={setHoraInicio} horaAtencionCita={horaInicioBloqueo} minutoCita={minutoInicioBloqueo} ampmCita={ampmInicioBloqueo} />
                                                                {errorlist && errorlist.fecha_hora_inicio && (
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.fecha_hora_inicio}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        
                                                        
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaFin">Fecha finalización</label>
                                                                <input type="date" name="fechaFin" className="form-control" id="fechaFin" defaultValue={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                                                                {errorlist && errorlist.fecha_fin && (
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.fecha_fin}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="horaFin">Hora de finalización</label>
                                                                <SelectorHora onChange={setHoraFin} horaAtencionCita={horaFinBloqueo} minutoCita={minutoFinBloqueo} ampmCita={ampmFinBloqueo} />
                                                                {errorlist && errorlist.fecha_hora_fin && (
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.fecha_hora_fin}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaFin">Repetir este bloqueo:</label>
                                                                <select name="frecuencia" className="form-control" id="frecuencia" defaultValue={frecuencia} onChange={(e) => setFrecuencia(e.target.value)}>
                                                                    {
                                                                        opcionesRepeticion.map((opcion) => {
                                                                            return opcion.visible ? <option value={opcion.value}>{opcion.text}</option> : '';
                                                                        })
                                                                    }
                                                                </select>
                                                                {errorlist && errorlist.frecuencia && (
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.frecuencia}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={'row '+showFechas}>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaFinRepeticion">Fecha fin repetición</label>
                                                                <input type="date" name="fechaFinRepeticion" className="form-control" id="fechaFinRepeticion" defaultValue={fechaFinRepeticion} onChange={(e) => setFechaFinRepeticion(e.target.value)} />
                                                                {errorlist && errorlist.fecha_fin_repeticion && (
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.fecha_fin_repeticion}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <Link to="/bloqueos-agenda" className="btn btn-secondary">
                                                Cancelar
                                            </Link>
                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                Guardar cambios
                                                {loading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                                            </button>
                                        </div>

                                    </form>

                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default EditarBloqueo;